import { getImageUrlFromName } from '../../../util'
import GradeIcon from '@mui/icons-material/Grade'
// import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactMoreReadLess from '../../common/ReadMoreReadLess/ReactMoreReadLess'
import rightArrow from '../../../assets/images/icons/media-right-arrow.svg'
import { useState } from 'react'
import ExpandDetail from './ExpandDetail'

const ReviewLayout = ({ layout, value, handleDetailPageClose }) => {
  const icon = require('../../../assets/images/checkCircle.svg').default
  let imageUrl = getImageUrlFromName(layout.icon_name)
  let firstValue
  if (value.length > 0) {
    firstValue = value[0]
  }
  const [showReview, setshowReview] = useState(false)

  // dialogues box
  const [open, setOpen] = useState(false)

  const handleExpandPageOpen = () => {
    setOpen(true)
  }

  const handleExpandPageClose = () => {
    setOpen(false)
  }
  //----

  return (
    <div
      style={{
        padding: '32px 20px 32px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#00ff00',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            textAlign: 'left',
            color: 'var(--gray100)',
          }}
        >
          <p className="title2">{layout.display_name}</p>
        </div>

        <div
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            textAlign: 'right',
            color: 'var(--gray100)',
          }}
        >
          <img
            style={{ width: '6rem', height: '6rem' }}
            src={imageUrl}
            alt=""
          />
        </div>
      </div>

      {/* First Review */}
      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <img
            src={firstValue.icon_url}
            alt=""
            style={{ marginRight: '8px', width: '20px', height: 'auto' }}
          ></img>
          <div>
            <div
              style={{
                display: 'block',
                alignItems: 'center',
                color: 'var(--gray80)',
              }}
            >
              <p
                className="headline2"
                style={{
                  margin: '0px',
                }}
              >
                {firstValue.source_title}
              </p>
            </div>
          </div>
        </div>
        {firstValue.rating_text && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: 'var(--gray60)',
            }}
          >
            <GradeIcon
              sx={{
                mr: 0.5,
                fontWeight: 400,
                fontSize: 15,
              }}
            />

            <p className="body3">{firstValue.rating_text}</p>
          </div>
        )}

        <div
          style={{
            display: 'block',
            alignItems: 'center',
            color: 'var(--gray100)',
          }}
        >
          <p
            className="body2"
            style={
              // firstValue.rating_text
              //   ? {
              //       marginTop: '-0.5rem',
              //     }
              //   : { marginTop: '0.5rem' }
              {
                marginTop: firstValue.rating_text ? '0px' : '8px',
                lineHeight: '150%',
              }
            }
          >
            <ReactMoreReadLess
              moreText={'More'}
              lessText={'Less'}
              showArrow={true}
              lines={'4'}
            >
              {firstValue.description}
            </ReactMoreReadLess>
          </p>
        </div>
      </div>

      {/*See all review */}
      {value.length > 0 && (
        <div>
          <button
            className="headline2"
            style={{
              background: 'var(--primaryTints90)',
              height: '40px',
              width: '100%',
              border: 'none',
              marginTop: '16px',
              color: 'var(--primaryShades20)',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              handleExpandPageOpen()
            }}
          >
            <span style={{ display: 'inline-flex' }} className="headline2">
              {'See all reviews'}{' '}
              <img
                src={rightArrow}
                alt="right-arrow"
                style={{ margin: '0px 3px' }}
              ></img>{' '}
            </span>
          </button>
          {/* <button
            onClick={(e) => {
              e.preventDefault()
              handleExpandPageOpen()
            }}
          >
            open dialog
          </button> */}
          <ExpandDetail
            open={open}
            handleExpandPageClose={handleExpandPageClose}
            handleDetailPageClose={handleDetailPageClose}
            value={value}
            layout={layout}
            imageUrl={imageUrl}
            contentType={'reviews'}
          />
        </div>
      )}
    </div>
  )
}

export default ReviewLayout
